const toInsurancePrice = (price) => {
  return { ...price };
};
const getInsurance = (insurance) => {
  if (!insurance) {
    return;
  }
  return insurance ? {
    sku: insurance.sku,
    name: insurance.name,
    id: insurance.id,
    price: {
      total: toInsurancePrice(insurance.price.total),
      unit: toInsurancePrice(insurance.price.unit)
    },
    policyNumber: insurance.policyNumber ?? void 0
  } : void 0;
};
export {
  getInsurance
};
//# sourceMappingURL=get-insurance.js.map
